"use client";

import { cn } from "@/lib/utils";

type BoundedProps = {
  as?: React.ElementType;
  className?: string;
  children: React.ReactNode;
};

export default function Bounded({
  as: Comp = "section",
  className,
  children,
  ...restProps
}: BoundedProps) {
  return (
    <Comp className={cn("", className)} {...restProps}>
      <div className="mx-auto px-4 md:px-6 lg:px-10 w-full container space-y-4">
        {children}
      </div>
    </Comp>
  );
}
